export default {
    realtimemaps_landmark_list_showAll: "Mostrar Todos",
    realtimemaps_landmark_list_hiddenAll: "Ocultar Todos",
};